import { useState } from "react";
import dayjs from "dayjs";
import ProcedureDocument from "./ProcedureDocument";
import {
  clockIconForDocument,
  eyeIconForDocument,
  fileIconForDocument,
  shareicon,
} from "../tabsvgs";
import ShareConfirmModal from "./docsharemodal";
import Base64ViewerModal from "./base64modal";
import OnBoardView from "../../../../onboarding/OnBoardView";
import DeleteLocalDocButton from "./DeleteLocalDocButton";

export const DocumentAllCards = ({ procedure, handleHtml, subview, patid, docLabels, onLocalDeleted }) => {
  // Prefer the AI/KG label (same as the timeline) over the raw description.
  const kgLabel = docLabels?.[
    procedure?.imagingresultid || procedure?.encounterdocumentid || procedure?.clinicaldocumentid
  ];
  const [isProcedureDocumentOpen, setIsProcedureDocumentOpen] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openBase64Viewer, setOpenBase64Viewer] = useState(false);
  const [selectedview, setSelectedView] = useState({});
  const [ismodal, setIsModal] = useState(false);
  const capitalizeFirst = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1);

  const cls = (procedure?.documentclass || "").trim().toLowerCase();
  const badgeClasses =
    cls === "imagingresult"
      ? "text-[#8200DB] bg-[#FAF5FF] border-[#E9D4FF]"
      : cls === "clinicaldocument"
        ? "text-[#007A55] bg-[#ECFDF5] border-[#A4F4CF]"
        : "text-[#1447E6] bg-[#EFF6FF] border-[#BEDBFF]";

  return (
    <div
      key={procedure.patientid}
      className="flex flex-col sm:flex-row justify-between items-center w-full gap-3 px-3 py-[18px] rounded-[12px] border border-[#232323]/10 bg-white"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full gap-4">
        <div className="flex items-center min-w-0 sm:w-1/4 gap-3">
          <div className="flex bg-[#50869A1A] p-2 rounded-[10px] shrink-0">
            {fileIconForDocument}
          </div>

          <div className="flex flex-col min-w-0 w-full text-left">
            <div className="text-[#101828] font-inter text-[14px] font-semibold truncate">
              {capitalizeFirst(
                kgLabel ||
                  procedure?.documentdescription ||
                  procedure?.note ||
                  procedure?.title ||
                  procedure?.exam ||
                  "",
              )}
              {procedure?.internalnote ? ` - ${procedure.internalnote}` : ""}
            </div>
          </div>
        </div>

        {/* Middle badge section */}
        {procedure.documentclass && procedure.source !== "openemr" ? (
          <span
            className={`inline-block mt-1 sm:mt-0 px-3 py-1 rounded-[10px] text-[12px] font-medium border ${badgeClasses} sm:w-[110px] text-center shrink-0`}
          >
            {procedure.documentclass === "IMAGINGRESULT"
              ? "Imaging"
              : procedure.documentclass === "CLINICALDOCUMENT"
                ? "Clinical"
                : procedure.documentclass === "Form"
                  ? "Form"
                  : procedure.documentclass === "Onboarding"
                    ? "Onboarding"
                    : "Encounter"}
          </span>
        ) : (
          <>
            <span
              className={`inline-block mt-1 sm:mt-0 px-3 py-1 rounded-[10px] text-[12px] font-medium sm:w-[110px] text-center shrink-0`}
            >{procedure.category_id === "13"
              ? "Clinical"
              : procedure.category_id === "32"
              ? "Imaging" : procedure.category_id === "2"
              ? "Labs" : procedure.category_id === "33"
              ? "Encounter"
              : "-"}</span>
          </>
        )}

        {/* Date */}
        <div className="flex items-center gap-1 text-[#4A5565] font-inter text-[12px] leading-[20px] sm:w-[140px] shrink-0 justify-end">
          {clockIconForDocument}
          {dayjs(procedure.createddate).format("MMMM D, YYYY")}
        </div>
        <div className="flex items-center gap-4">
          <DeleteLocalDocButton
            procedure={procedure}
            patid={patid}
            onDeleted={onLocalDeleted}
          />
          {procedure.documentclass !== "Onboarding" && (
            <button
              onClick={() => {
                setOpenShareModal(true);
              }}
              className="inline-flex shadow-md items-center gap-3 rounded-xl text-[#5C8496] px-2.5 py-2 bg-white text-[12px] font-inter font-medium hover:opacity-90 focus:outline-none shrink-0 sm:w-[90px] justify-center"
            >
              {shareicon}
              Share
            </button>
          )}
          <button
            onClick={() => {
              if (procedure?.imgbasefile) {
                setOpenBase64Viewer(true);
              } else if (procedure.documentclass === "Onboarding") {
                setSelectedView(procedure);
                setIsModal(true);
              } else if (procedure.documentclass === "Form") {
                handleHtml(procedure);
              } else {
                setIsProcedureDocumentOpen(true);
              }
            }}
            className="inline-flex items-center gap-3 rounded-xl bg-[#5C8496] px-2.5 py-2 text-white text-[12px] font-inter font-medium hover:opacity-90 focus:outline-none shrink-0 sm:w-[90px] justify-center"
          >
            {eyeIconForDocument}
            View
          </button>
        </div>
        {/* Button */}
      </div>
      <ShareConfirmModal
        patid={patid}
        open={openShareModal}
        onClose={() => setOpenShareModal(false)}
        procedure={procedure}
        subview={subview}
      />
      <Base64ViewerModal
        open={openBase64Viewer}
        onClose={() => setOpenBase64Viewer(false)}
        base64={procedure?.imgbasefile}
      />

      <ProcedureDocument
        subview={subview}
        isProcedureDocumentOpen={isProcedureDocumentOpen}
        setIsProcedureDocumentOpen={setIsProcedureDocumentOpen}
        procedure={{ ...procedure, patientid: procedure?.patientid ?? patid }}
      />
      <OnBoardView
        ismodal={ismodal}
        setIsModal={setIsModal}
        data={selectedview}
      />
    </div>
  );
};
